import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { attemptLoginAction } from '../../../actions/authActions';
// import AppButton from '../../atoms/AppButton/AppButton';
import logoImg from '../../../img/pages/login/logo.svg';
import dollerIcon from '../../../img/pages/app-selection/doller.svg';
import bankIcon from '../../../img/pages/app-selection/bank.svg';
import stockIcon from '../../../img/pages/app-selection/stock.svg';
import artIcon from '../../../img/pages/app-selection/arts.svg';
import networthIcon from '../../../img/pages/app-selection/networth.svg';
import FullPageLoader from '../../organisms/FullPageLoader/FullPageLoader';

class AppSelection extends Component {
  static propTypes = {
    attemptLogin: PropTypes.func.isRequired,
    permissions: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  login(ev) {
    ev.preventDefault();
    const { username, password } = this.state;
    const { attemptLogin } = this.props;
    attemptLogin(username, password);
  }

  render() {
    const {
      assets, familyOs, stocks, arts, networth,
    } = window.config.apps;
    const { permissions } = this.props;

    const onAppSelected = (appUrl) => {
      window.location.replace(`${appUrl}`);
    };

    const displayFamilyOs =
      familyOs.enabled &&
      (permissions.indexOf('admin') !== -1 ||
        permissions.indexOf('import') !== -1 ||
        permissions.indexOf('categorize') !== -1 ||
        permissions.indexOf('categorize') !== -1 ||
        permissions.indexOf('view_imports') !== -1 ||
        permissions.indexOf('view_transactions') !== -1 ||
        permissions.indexOf('dashboard_and_stats') !== -1 ||
        permissions.indexOf('setignore') !== -1);

    const displayStocks =
      stocks.enabled &&
      (permissions.indexOf('admin') !== -1 ||
        permissions.indexOf('treasury_stocks') !== -1);

    const displayArts =
        arts.enabled &&
        (permissions.indexOf('admin') !== -1 ||
          permissions.indexOf('treasury_valuable_arts') !== -1);

    const displayAssets =
      assets.enabled &&
      (permissions.indexOf('admin') !== -1 ||
        permissions.indexOf('treasury_real_estates') !== -1 ||
        permissions.indexOf('treasury_company_investments') !== -1 ||
        permissions.indexOf('treasury_liabilities') !== -1 ||
        permissions.indexOf('treasury_misc_investments') !== -1 ||
        permissions.indexOf('treasury_valuable_arts') !== -1 ||
        permissions.indexOf('treasury_valuable_designs') !== -1);

    const displayNetworth =
      networth.enabled &&
        (permissions.indexOf('admin') !== -1);

    return (
      <div className="app-selection-page-wrapper align-items-start">
        <FullPageLoader />
        <div className="app-selection-page-wrapper">
          <div className="page-title-header">
            <div className="img__logo__section">
              <img src={logoImg} alt="logo" />
            </div>
          </div>

          {/* app cards item */}
          <div className="app-selection-items-wrapper">
            <div className="card-group-grid-items">
              {displayStocks ? (
                <button
                  type="button"
                  className="card p-3 card-border-radius"
                  onClick={() => onAppSelected(stocks?.url)}
                >
                  <div className="card-item-body">
                    <img src={stockIcon} alt="stock" />
                    <div className="card-text-items">
                      <h2>TREASURY</h2>
                      <h5>STOCKS</h5>
                    </div>
                  </div>
                </button>
              ) : (
                ''
              )}

              {displayArts ? (
                <button
                  type="button"
                  className="card p-3 card-border-radius"
                  onClick={() => onAppSelected(arts?.url)}
                >
                  <div className="card-item-body">
                    <img src={artIcon} alt="art" style={{ width: '64px', height: '62px' }} />
                    <div className="card-text-items">
                      <h2>TREASURY</h2>
                      <h5>ART &amp; LUXURY</h5>
                    </div>
                  </div>
                </button>
              ) : (
                ''
              )}

              {displayFamilyOs ? (
                <button
                  type="button"
                  className="card p-3 card-border-radius"
                  onClick={() => onAppSelected(familyOs?.url)}
                >
                  <div className="card-item-body">
                    <img src={dollerIcon} alt="doller icon" />
                    <div className="card-text-items">
                      <h2>TREASURY</h2>
                      <h5>COSTS</h5>
                    </div>
                  </div>
                </button>
              ) : (
                ''
              )}

              {displayAssets ? (
                <button
                  type="button"
                  className="card p-3 card-border-radius"
                  onClick={() => onAppSelected(assets?.url)}
                >
                  <div className="card-item-body">
                    <img src={bankIcon} alt="bank build" />
                    <div className="card-text-items">
                      <h2>TREASURY</h2>
                      <h5>ASSETS</h5>
                    </div>
                  </div>
                </button>
              ) : (
                ''
              )}

              {displayNetworth ? (
                <button
                  type="button"
                  className="card p-3 card-border-radius"
                  onClick={() => onAppSelected(networth?.url)}
                >
                  <div className="card-item-body">
                    <img src={networthIcon} alt="art" />
                    <div className="card-text-items">
                      <h2>TREASURY</h2>
                      <h5>NET WORTH</h5>
                    </div>
                  </div>
                </button>
              ) : (
                ''
              )}

            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  permissions: state.auth.user.permissions,
});
const mapDispatchToProps = dispatch => ({
  attemptLogin: (username, password) => dispatch(attemptLoginAction(username, password)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AppSelection);
